import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  makeStyles,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useEffect, useState } from "react";
import { formState, FormStore } from "../services/form.store";
import { CONDITIONAL_FORM } from "../utility/Constant";
import ConditionalForm from "./ConditionalForm";

const EditConditionalForm = ({ showEditHierarchy, setShowEditHierarchy }) => {
  const useStyles = makeStyles(() => ({
    editHierarchyBtn: {
      marginLeft: "16px",
    },
    dialogPaper: {
      minHeight: "10%",
      maxheight: "80%",
      minWidth: "60%",
      padding: "6px",
    },
    popoverContent: { padding: "16px", maxWidth: "250px" },
  }));
  const [isConditionalForm, setIsConditionalForm] = useState(false);
  const [universalHierarchyData, setUniversalHierarchyData] = useState({});
  const [isConditionalLoading, setIsConditionalLoading] = useState(false);
  const [isUniversalHierarchyChanged, setIsUniversalHierarchyChanged] =
    useState(false);
  const [createFormClicked, setCreateFormClicked] = useState(false);
  const [isConditionalFormValid, setIsConditionalFormValid] = useState(true);
  const classes = useStyles();

  useEffect(() => {
    const formSubscription = formState.subscribe((response) => {
      if (response.formType === CONDITIONAL_FORM.CONDITIONAL) {
        setIsConditionalForm(true);
        setUniversalHierarchyData(response.universalHierarchy);
      }
    });
    return () => formSubscription.unsubscribe();
  }, []);

  const handleConditionalFormValidation = (isValid) => {
    setIsConditionalFormValid(isValid);
  };

  const updateHierarchy = () => {
    if (isConditionalForm && isConditionalFormValid) {
      FormStore.sharedInstance().setFormType(CONDITIONAL_FORM.CONDITIONAL);
      if (isUniversalHierarchyChanged) {
        FormStore.sharedInstance().setUpdatedUniversalHierarchy(
          universalHierarchyData,
        );
        FormStore.sharedInstance().removeUniversalTagging();
      }
    } else {
      FormStore.sharedInstance().setFormType(null);
      FormStore.sharedInstance().setUpdatedUniversalHierarchy(null);
      FormStore.sharedInstance().removeUniversalTagging();
    }
    if (isConditionalFormValid) {
      FormStore.sharedInstance().shouldNavigate(true);
      setShowEditHierarchy(false);
    }
  };

  return (
    <>
      <Dialog
        open={showEditHierarchy}
        onClose={() => setShowEditHierarchy(false)}
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogContent>
          <ConditionalForm
            isConditionalForm={isConditionalForm}
            setIsConditionalForm={setIsConditionalForm}
            onValidation={handleConditionalFormValidation}
            universalHierarchyData={universalHierarchyData}
            setUniversalHierarchyData={setUniversalHierarchyData}
            isConditionalLoading={isConditionalLoading}
            setIsConditionalLoading={setIsConditionalLoading}
            isUniversalHierarchyChanged={isUniversalHierarchyChanged}
            setIsUniversalHierarchyChanged={setIsUniversalHierarchyChanged}
            editHierarchy={true}
            createFormClicked={createFormClicked}
          />
        </DialogContent>
        <DialogActions>
          <Alert variant="filled" severity="error">
            Caution: Altering the hierarchy will remove existing conditions. Are
            you sure you want to continue?
          </Alert>
          <Button
            variant="outlined"
            onClick={() => setShowEditHierarchy(false)}
            color="primary"
            disabled={isConditionalLoading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={(e) => {
              updateHierarchy();
              setCreateFormClicked(true);
            }}
            color="success"
            disabled={isConditionalLoading}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditConditionalForm;
